export const DATE_FORMAT = {
  US: 'MM/dd/yyyy',
  default: 'dd/MM/yyyy',
};

export const DATE_FORMAT_PLACEHOLDER = {
  US: 'mm/dd/yyyy',
  default: 'dd/mm/yyyy',
};
